import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities as getVirtualFenceCircles } from 'app/entities/virtual-fence-circle/virtual-fence-circle.reducer';
import { getEntities as getVehiclePositions } from 'app/entities/vehicle-position/vehicle-position.reducer';
import { getEntity, updateEntity, createEntity, reset } from './virtual-fence-circle-alert.reducer';
import { convertDateTimeToPtBRWithYearWithoutSeconds } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VirtualFenceCircleAlertUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const virtualFenceCircles = useAppSelector(state => state.virtualFenceCircle.entities);
  const vehiclePositions = useAppSelector(state => state.vehiclePosition.entities);
  const virtualFenceCircleAlertEntity = useAppSelector(state => state.virtualFenceCircleAlert.entity);
  const loading = useAppSelector(state => state.virtualFenceCircleAlert.loading);
  const updating = useAppSelector(state => state.virtualFenceCircleAlert.updating);
  const updateSuccess = useAppSelector(state => state.virtualFenceCircleAlert.updateSuccess);

  const handleClose = () => {
    props.history.push('/virtual-fence-circle-alert' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getVirtualFenceCircles({}));
    dispatch(getVehiclePositions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...virtualFenceCircleAlertEntity,
      ...values,
      virtualFenceCircle: virtualFenceCircles.find(it => it.id.toString() === values.virtualFenceCircleId.toString()),
      vehiclePosition: vehiclePositions.find(it => it.id.toString() === values.vehiclePositionId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...virtualFenceCircleAlertEntity,
          virtualFenceCircleId: virtualFenceCircleAlertEntity?.virtualFenceCircle?.id,
          vehiclePositionId: virtualFenceCircleAlertEntity?.vehiclePosition?.id,
        };
  
  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.virtualFenceCircleAlert.home.createOrEditLabel" data-cy="VirtualFenceCircleAlertCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.virtualFenceCircleAlert.home.createOrEditLabel">
              Create or edit a VirtualFenceCircleAlert
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="virtual-fence-circle-alert-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  hidden
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.virtualFenceCircleAlert.type')}
                id="virtual-fence-circle-alert-type"
                name="type"
                data-cy="type"
                type="text"
              />
              <ValidatedField
                id="virtual-fence-circle-alert-virtualFenceCircle"
                name="virtualFenceCircleId"
                data-cy="virtualFenceCircle"
                label={translate('fleetSenseApp.virtualFenceCircleAlert.virtualFenceCircle')}
                type="select"
              >
                <option value="" key="0" />
                {virtualFenceCircles
                  ? virtualFenceCircles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="virtual-fence-circle-alert-vehiclePosition"
                name="vehiclePositionId"
                data-cy="vehiclePosition"
                label={translate('fleetSenseApp.virtualFenceCircleAlert.vehiclePosition')}
                type="select"
              >
                <option value="" key="0" />
                {vehiclePositions
                  ? vehiclePositions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {convertDateTimeToPtBRWithYearWithoutSeconds(otherEntity.created)}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('fleetSenseApp.virtualFenceCircleAlert.description')}
                id="virtual-fence-circle-alert-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/virtual-fence-circle-alert" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default VirtualFenceCircleAlertUpdate;
